var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTokenSample(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6216 0.85942C18.7283 -0.286473 21.2721 -0.286474 23.3787 0.85942L35.5915 7.50256C37.8671 8.74033 39.2836 11.1233 39.2836 13.7137V26.2863C39.2836 28.8767 37.8671 31.2597 35.5915 32.4974L23.3787 39.1406C21.2721 40.2865 18.7283 40.2865 16.6216 39.1406L4.40883 32.4974C2.1333 31.2597 0.716797 28.8767 0.716797 26.2863L0.716797 13.7137C0.716797 11.1233 2.1333 8.74033 4.40882 7.50256L16.6216 0.85942Z",
    fill: "#5542A9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenSample);
export default __webpack_public_path__ + "static/media/token-sample.564eac2300b4331c310dfba375ef8d67.svg";
export { ForwardRef as ReactComponent };